import { useTranslate } from '@tolgee/react';
import { BaseSysMsgProps } from './types';
import { SystemMessage } from 'components/Dialogue';
import dayjs from 'lib/dayjs';
import { toNumber } from 'lodash-es';
import { memo } from 'react';

export const SysAutoMarkSalesStatusMsg = memo((props: BaseSysMsgProps) => {
  const { raw } = props;
  const { t } = useTranslate();

  if (raw?.sysAutoMarkSalesStatusContent) {
    const { timestamp, salesStatus } = raw.sysAutoMarkSalesStatusContent;
    const salesStatusMap: Record<string, string> = {
      BEFORE_SALES_STATUS: t('aide.售前买家'),
      DURING_SALES_STATUS: t('aide.售中买家'),
      AFTER_SALES_STATUS: t('aide.售后买家'),
    };

    return (
      <SystemMessage>
        {t('ViewsChat.修改sales状态', {
          time: dayjs(toNumber(timestamp)).format('MM-DD HH:mm:ss'),
          who: t('cancelType.system'),
          buyerWho: salesStatusMap[salesStatus],
        })}
      </SystemMessage>
    );
  }

  return null;
});
